import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from "../../helper/urls";
import { useSelector } from "react-redux";

const ResetPassword = () => {
  const { token } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { oldPassword, newPassword, confirmPassword } = formData;

    if (newPassword !== confirmPassword) {
      toast.error("New Password and Confirm Password do not match");
      return;
    }

    try {
      if (!token) {
        toast.error("User not authenticated");
        return;
      }

      const response = await axios.post(
        `${baseUrl}/api/counselors/profileResetPassword`,
        {
          old_password: oldPassword,
          new_password: newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Password reset successfully!");
      setFormData({ oldPassword: "", newPassword: "", confirmPassword: "" });
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message || "Failed to reset password";
      toast.error(errorMsg);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={2000} />
      <div className="h-100 p-0 radius-12">
        <div className="row justify-content-center">
          <div
            className="col-xxl-6 col-xl-6 col-lg-6"
            style={{ padding: "100px 0" }}
          >
            <div className="card border">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    {/* Old Password */}
                    <div className="col-sm-12">
                      <div className="mb-20">
                        <label
                          htmlFor="oldPassword"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Old Password{" "}
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="password"
                          className="form-control radius-8"
                          id="oldPassword"
                          name="oldPassword"
                          placeholder="Enter old password"
                          value={formData.oldPassword}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* New Password */}
                    <div className="col-sm-12">
                      <div className="mb-20">
                        <label
                          htmlFor="newPassword"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          New Password{" "}
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="password"
                          className="form-control radius-8"
                          id="newPassword"
                          name="newPassword"
                          placeholder="Enter new password"
                          value={formData.newPassword}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Confirm Password */}
                    <div className="col-sm-12">
                      <div className="mb-20">
                        <label
                          htmlFor="confirmPassword"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Confirm Password{" "}
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="password"
                          className="form-control radius-8"
                          id="confirmPassword"
                          name="confirmPassword"
                          placeholder="Confirm new password"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="col-sm-12 text-center">
                      <button
                        type="submit"
                        className="btn btn-primary rounded-pill px-5 py-2"
                        style={{ height: "45px" }}
                      >
                        Reset Password
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;

// import React, { useState } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const ResetPassword = () => {
//   const [formData, setFormData] = useState({
//     oldPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//   });

//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (formData.newPassword !== formData.confirmPassword) {
//       toast.error("New Password and Confirm Password do not match");
//       return;
//     }

//     // Handle password reset API here
//     toast.success("Password reset successfully!");
//   };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={2000} />
//       <div className="card h-100 p-0 radius-12">
//         <div className="row justify-content-center">
//           <div className="col-xxl-6 col-xl-6 col-lg-6">
//             <div className="card border">
//               <div className="card-body">
//                 <form onSubmit={handleSubmit}>
//                   <div className="row">
//                     {/* Old Password */}
//                     <div className="col-sm-12">
//                       <div className="mb-20">
//                         <label
//                           htmlFor="oldPassword"
//                           className="form-label fw-semibold text-primary-light text-sm mb-8"
//                         >
//                           Old Password{" "}
//                           <span className="text-danger-600">*</span>
//                         </label>
//                         <input
//                           type="password"
//                           className="form-control radius-8"
//                           id="oldPassword"
//                           name="oldPassword"
//                           placeholder="Enter old password"
//                           value={formData.oldPassword}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>
//                     {/* New Password */}
//                     <div className="col-sm-12">
//                       <div className="mb-20">
//                         <label
//                           htmlFor="newPassword"
//                           className="form-label fw-semibold text-primary-light text-sm mb-8"
//                         >
//                           New Password{" "}
//                           <span className="text-danger-600">*</span>
//                         </label>
//                         <input
//                           type="password"
//                           className="form-control radius-8"
//                           id="newPassword"
//                           name="newPassword"
//                           placeholder="Enter new password"
//                           value={formData.newPassword}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>
//                     {/* Confirm Password */}
//                     <div className="col-sm-12">
//                       <div className="mb-20">
//                         <label
//                           htmlFor="confirmPassword"
//                           className="form-label fw-semibold text-primary-light text-sm mb-8"
//                         >
//                           Confirm Password{" "}
//                           <span className="text-danger-600">*</span>
//                         </label>
//                         <input
//                           type="password"
//                           className="form-control radius-8"
//                           id="confirmPassword"
//                           name="confirmPassword"
//                           placeholder="Confirm new password"
//                           value={formData.confirmPassword}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>
//                     {/* Submit Button */}
//                     <div className="col-sm-12">
//                       <button
//                         type="submit"
//                         className="btn btn-primary rounded-pill px-5 py-2"
//                       >
//                         Reset Password
//                       </button>
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ResetPassword;
